import React, {useEffect} from "react";
import { servicesList } from "../../list";
import { Link } from "react-router-dom";
import "./services-list.css";

function createHtmlList(obj, activeOne) {
  let output = [];
  for (let k in obj) {
    let key = Math.floor(Math.random() * 1000);
    if (typeof obj[k] === "object" && !("title" in obj[k]) && obj[k] !== null) {
      output.push(
        <li key={key}>
          {k} {createHtmlList(obj[k], activeOne)}
        </li>
      );
    } else {
      if (obj[k].title === activeOne) {
        output.push(
          <li key={key} className="active">
            {<Link to={`/service-detail/${obj[k].id}`} target="_blank" disabled={obj[k].underConstruction}>{obj[k].title}</Link>}
          </li>
        );
      }
      else
        output.push(
          <li key={key}>
            {<Link to={`/service-detail/${obj[k].id}`} target="_blank" disabled={obj[k].underConstruction}>{obj[k].title}</Link>}
          </li>
        );
    }
  }

  return <ul key={Math.random()}>{output}</ul>;
}

function ServicesList({ className, activeOne }) {
  let classes = ["services-list", className].join(" ");

  useEffect(() => {
    document.querySelector('li.active').closest('ul').closest('li').classList.add('red');
  }, []);

  return (
    <div className={classes}>{createHtmlList(servicesList, activeOne)}</div>
  );
}

export default ServicesList;
